import PropTypes from 'prop-types';
// @mui
import { Typography, Stack, Chip, Card, CardContent, Button } from '@mui/material';
// components
import Label from '../../components/Label';
import Iconify from '../../components/Iconify';
// utils
import { fKSTDateAbsoluteDuration } from '../../utils/formatTime';

// ------------------------------

TodoCard.propTypes = {
  standup: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
};

const daysTo = (end) => {
  let diff = new Date(end).getTime() - new Date().getTime();
  let diffInDays = diff / (1000 * 3600 * 24);
  return Number.parseInt(diffInDays);
};

const getBadge = (active, start, end) => {
  if (active) {
    return `정산 D-${daysTo(end)}`
  } else {
    return `${fKSTDateAbsoluteDuration(start)} ~ ${fKSTDateAbsoluteDuration(end)}`
  }
};

const getDescription = (active, week_in_progress, weeks) => {
  if (active) {
    return `${week_in_progress}주차 진행중`;
  } else {
    return `${weeks}주간 근무`;
  }
};

export default function TodoCard({ standup, onClick }) {
  const endDate = new Date(standup.end_at);
  const isActive = new Date() < endDate;
  const badge = getBadge(isActive, standup.start_at, standup.end_at);
  const description = getDescription(isActive, standup.week_in_progress, standup.weeks);

  return (
    <Card
      onClick={onClick}
      variant="outlined"
      sx={{
        padding: (theme) => theme.spacing(1),
        height: 260,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        '&:hover': {
          cursor: 'pointer',
          boxShadow: (theme) => theme.customShadows.z24,
        },
      }}
    >
      <CardContent>
        <Stack spacing={1} sx={{ mb: 2, display: 'block' }}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Typography
              variant="subtitle1"
            >
              {standup.company_name}
            </Typography>
            <Label
              variant="filled"
              color={isActive ? "primary" : "default"}
            >
              {isActive ? standup?.todo_count || 0 : `${standup.done_count || 0}개 완료` }
            </Label>
          </Stack>
          <Typography
            variant={isActive ? "subtitle2" : "body2"}
            sx={{ color: (theme) => theme.palette.grey[600] }}
          >
            {description}
          </Typography>
          <Chip variant="outlined" label={badge} sx={{ fontWeight: isActive ? 600 : 400 }} />
        </Stack>
        <Button
          sx={{ color: (theme) => isActive ? 'default' : theme.palette.grey[500] }}
          color={ isActive ? "secondary" : "primary" }
          endIcon={<Iconify icon={'ic:baseline-arrow-right-alt'} />}>
          {isActive ? '데일리 투두 확인' : '데일리 투두 기록 보기'}
        </Button>
      </CardContent>
    </Card>
  );
};
